import React, { useState } from 'react';
import { handleVenderLogOut } from '../../HelperMethods';
import { useNavigate } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher';
import Cookies from "js-cookie";

const VendorDashboardHeader = ({ isLanguageSwitcher = false }) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = () => {
    handleVenderLogOut();
    navigate('/VendorLogin');
    setIsDropdownOpen(false);
  };

  // You can dynamically get these values later (from auth context/user)
  const userName = Cookies.get("NIGHT_EYE_USER_NAME") || "V";           // ← Change as needed
  // const userName = "V";           // ← Change as needed
  const initials = userName?.split(' ')?.map(word => word?.[0])?.join('')?.slice(0, 2)?.toUpperCase();                     // e.g. "VD" or "JS"

  return (
    <header className="sticky top-0 z-50 flex items-center justify-between border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-5 sm:px-6 py-3 shadow-sm">
      {/* Left - Logo & Title */}
      <div className="flex items-center gap-3">
        <div className="h-8 w-8 text-indigo-600">
          <svg fill="currentColor" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 4C25.7818 14.2173 33.7827 22.2182 44 24C33.7827 25.7818 25.7818 33.7827 24 44C22.2182 33.7827 14.2173 25.7818 4 24C14.2173 22.2182 22.2182 14.2173 24 4Z" />
          </svg>
        </div>
        <h2 className="text-gray-900 dark:text-white text-lg font-bold tracking-tight">
          Vendor Portal
        </h2>
      </div>

      {/* Right - Profile Dropdown */}
      <div className="relative flex gap-2">
        {isLanguageSwitcher && <div className="hidden sm:flex items-center gap-4 text-xs font-bold font-medium text-slate-600 dark:text-slate-400">
          <a ><LanguageSwitcher /></a>
        </div>}
        <button
          type="button"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="flex items-center gap-3 focus:outline-none"
        >
          {/* Avatar with initials */}
          <div className="h-10 w-10 rounded-full bg-indigo-600 text-white flex items-center justify-center font-medium text-sm ring-2 ring-white dark:ring-gray-800 shadow-sm">
            {initials}
          </div>

          {/* Optional: name + chevron (you can remove if you want minimal) */}
          <div className="hidden sm:flex items-center gap-1.5">
            {/* <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              {userName}
            </span> */}
            {/* <svg
              className={`w-4 h-4 text-gray-500 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg> */}
          </div>
        </button>

        {/* Dropdown Menu */}
        {isDropdownOpen && (
          <>
            {/* Backdrop (mobile friendly close) */}
            <div
              className="fixed inset-0 z-30 md:hidden"
              onClick={() => setIsDropdownOpen(false)}
            />

            <div className="
              absolute right-0 top-full mt-2 w-56 
              bg-white dark:bg-gray-800 
              rounded-lg shadow-xl border border-gray-200 dark:border-gray-700
              overflow-hidden z-40
              origin-top-right
              animate-in fade-in zoom-in-95 duration-150
            ">
              <div className="py-1.5 px-4 border-b border-gray-100 dark:border-gray-700">
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  {userName}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  Vendor
                </p>
              </div>

              <button
                onClick={handleLogout}
                className="
                  w-full text-left px-4 py-2.5 text-sm
                  text-red-600 dark:text-red-400 
                  hover:bg-gray-50 dark:hover:bg-gray-700/70
                  transition-colors
                "
              >
                Log Out
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default VendorDashboardHeader;